import { ReactNode, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { getLinks, markup } from '../utils/markup';

export default function useIntlLight(links?: Record<string, string>) {
  const intl = useIntl();

  const trans = useMemo(() => {
    return (key?: string, params?: Record<string, any>) => {
      if (!key) return '';
      const values = {
        ...markup,
        ...(links ? getLinks(links) : {}),
        ...params,
      };

      return intl.formatMessage({ id: key }, values);
    };
  }, [intl, links]);

  return { trans, locale: intl.locale, t: trans };
}
